<script setup lang="ts">
import { computed, ref } from 'vue';

import AuthFlow from '../../auth/components/AuthFlow.vue';
import type { AuthenticationDestination, AuthenticationStart } from '../../auth/types.ts';
import { usePublicFlowAdapter } from '../adapter.ts';

const props = defineProps<{
    intended: string;
    registration?: { referrer_id?: number };
}>();

const destination = ref<AuthenticationDestination>('register');
const adapter = usePublicFlowAdapter();
const start = computed<AuthenticationStart>(() => {
    if (destination.value === 'register') {
        return { screen: 'entry', mode: 'register', registration: props.registration };
    }

    if (destination.value === 'login') {
        return { screen: 'entry', mode: 'login' };
    }

    return { screen: 'password-recovery' };
});
</script>

<template>
    <AuthFlow
        :intended="intended"
        :start="start"
        @complete="adapter.navigate($event || intended)"
        @navigate="destination = $event"
    />
</template>
